export default {
    imageAIFormRules: {
        enterDescription: 'Veuillez saisir la description',
        invalidDescription: 'Veuillez saisir une description valide',
        enterNumberOfVariations: 'Veuillez sélectionner le nombre de variations',
        invalidNumberOfVariations: 'You can generate maximum 4 and minimum 1 variation',
        enterStyle: 'Please select at least one style',
    },
};
